import theme from 'theme_'

import styled from 'styled-components'

export const CollapseContainer = styled.div`
  width: 100%;
  background ${theme.colors.white};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
`

export const CollapseBody = styled.div<{ open: boolean }>`
  max-height: ${({ open }) => (open ? '2400px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`

export const CollapseContent = styled.div`
  padding: 0 24px 24px;
`
